import template from './transaction-details.html';
import controller from './transaction-details.controller';

let transactionDetailsComponent = {
  restrict: 'E',
  bindings: {
    transactionId: '@?',
    isModal: '<?',
    onClose: '&?'
  },
  template,
  controller
};

export default transactionDetailsComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/transaction-details/transaction-details.component.js